export function markdownConfig ($showdownProvider) {
  'ngInject';
  // for more options visit https://github.com/showdownjs/showdown
  $showdownProvider.setOption('simpleLineBreaks' , true);
  $showdownProvider.setOption('simplifiedAutoLink' , true);
  $showdownProvider.setOption('smartIndentationFix' , true);
  $showdownProvider.setOption('openLinksInNewWindow' , true);
}